var _style, _path, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 60",
    style: {
      enableBackground: "new 0 0 180 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st1{clip-path:url(#SVGID_00000032637441561993271640000006516152170768120229_);}\n\t.st2{fill:#D7CCFF;}\n\t.st3{fill:#B198F8;}\n\t.st4{fill:#250051;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#8258F3;}\n\t.st7{fill:#F5438C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.7,38.1c-4.4-4.2,0.7-12.3,12.8-16.2c37.2-12.1,79.8-1.2,79.8-1.2s21.8,1.9,35.4,6.1c5,1.5,4.6,8.7-0.5,9.7 l-21.3,4.1c-6.2,1.2-12.6,1.5-18.8,0.8s-5.5-0.8-8.1-1.4l-4.4-1c-9-2.1-18.2-2.4-27.3-0.9c-15.6,2.5-42.7,4.6-47.4,0.1L33.7,38.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -1,
    y: -1,
    width: 182,
    height: 62
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096755324653778597520000005793290014323880368_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000096755324653778597520000005793290014323880368_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78,33.5c0.4,0.6,0.4,1.2,0.2,1.5c0.3,0.1,0.6,0.4,0.9,0.7c0.2,0.4,0.3,0.8,0.3,1.1 c0.2,0.1,0.5,0.4,0.7,0.7c0.1,0.2,0.2,0.5,0.2,0.8c0.1,1-0.4,2-1.3,2.5l-6.7,3.8L51.4,69.4c-2.2,2.6-6.2,2.9-8.7,0.5l0,0 c-2.5-2.3-3.8-5.8-0.8-9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.2,34.9l-4.9,2.8c-0.6,0.3-0.8,1.1-0.5,1.8l0,0c0.3,0.6,1.1,0.8,1.8,0.5l0.7-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.4,34l-2.1,1.3c-0.6,0.3-0.8,1.1-0.5,1.8l0,0c0.3,0.6,1.1,0.8,1.8,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.3,36.9l-3.8,2.3c-0.6,0.3-0.8,1.1-0.5,1.8l0,0c0.3,0.6,1.1,0.8,1.8,0.5l2.2-1.2"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "75.8,42.6 73.4,44 70.7,39.8 71.4,35.9 74.7,36.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.2,40.5L89.5,8.8C89.8,8.3,90.4,8,91,8.2l18.7,7.9c0.6,0.2,0.8,0.9,0.6,1.4L96.9,49.3 c-0.2,0.6-0.9,0.8-1.4,0.6L76.8,42C76.2,41.7,76,41.1,76.2,40.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M77.4,40L90,10.1c0.2-0.6,0.9-0.8,1.4-0.6l17.1,7.2c0.6,0.2,0.8,0.9,0.6,1.4L96.6,48 c-0.2,0.6-0.9,0.8-1.4,0.6L78,41.4C77.4,41.2,77.2,40.5,77.4,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M70.9,38.3L84.3,6.6c0.2-0.6,0.9-0.8,1.4-0.6l21.4,9c0.6,0.2,0.8,0.9,0.6,1.4L94.3,48.2 c-0.2,0.6-0.9,0.8-1.4,0.6l-21.4-9C71,39.5,70.7,38.9,70.9,38.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "77.4,23.1 73.6,32.2 84.8,33.8 86,26.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M80.5,27.4l8.4-20l-1.7-0.7l-8.4,20c0,0.1,0,0.2,0.2,0.1l1.1-0.8l0.2,1.4C80.3,27.5,80.5,27.5,80.5,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.8,61l24.5-23.1c0.2-0.2,0.4-0.4,0.5-0.7c0.6-1.1,2.8-4.4,3.5-4.8s5.3-1.4,5.3-1.4c0.8-0.2,1.7,0.2,1.9,1 l0,0c0.2,0.8-0.3,1.4-1.1,1.6l-2.2,0.6c-0.9,0.2-1.5,0.9-1.7,1.8c-0.3,1.3-1,3.3-2.3,4.4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration4);
export default __webpack_public_path__ + "static/media/illustration4.49731995750f7a2dcb5a1925cd660a1e.svg";
export { ForwardRef as ReactComponent };